import React from 'react';
import { Link } from 'react-router-dom';
import { TruckIcon, ArrowLeft, FileText } from 'lucide-react';
import '../styles/modern.css';

export const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #f9fafb 0%, #e5e7eb 100%)' }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #2563eb 100%)',
        padding: '24px 0'
      }}>
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 text-white">
              <div style={{
                background: 'rgba(255, 255, 255, 0.15)',
                padding: '10px',
                borderRadius: '10px',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.2)'
              }}>
                <TruckIcon className="w-6 h-6" />
              </div>
              <span className="text-xl font-bold">Transportation Safety Platform</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-sm mb-8"
          style={{ color: 'var(--color-gray-600)' }}
        >
          <ArrowLeft className="w-4 h-4" />
          Back to login
        </Link>

        <div style={{
          background: 'white',
          borderRadius: 'var(--radius-xl)',
          padding: '48px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
          border: '1px solid var(--color-gray-200)'
        }}>
          <div className="flex items-center gap-4 mb-8">
            <div style={{
              width: '56px',
              height: '56px',
              background: 'linear-gradient(135deg, #1e40af 0%, #2563eb 100%)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <FileText className="w-7 h-7 text-white" />
            </div>
            <h1 className="text-3xl font-bold" style={{ color: 'var(--color-gray-900)' }}>
              Terms of Service
            </h1>
          </div>

          <div className="prose max-w-none" style={{ color: 'var(--color-gray-700)' }}>
            <p className="text-muted mb-6">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

            <h2 className="text-xl font-semibold mt-8 mb-4" style={{ color: 'var(--color-gray-900)' }}>1. Acceptance of Terms</h2>
            <p className="mb-4">
              By accessing or using the Transportation Safety Platform ("TSAP"), you agree to be bound 
              by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4" style={{ color: 'var(--color-gray-900)' }}>2. Description of Service</h2>
            <p className="mb-4">
              TSAP provides transportation safety analytics, carrier monitoring, compliance tracking, 
              and related services to help organizations manage fleet safety and regulatory compliance.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4" style={{ color: 'var(--color-gray-900)' }}>3. User Accounts</h2>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>You must provide accurate and complete registration information</li>
              <li>You are responsible for maintaining the security of your account</li>
              <li>You must notify us immediately of any unauthorized access</li>
              <li>You may not share your account credentials with others</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4" style={{ color: 'var(--color-gray-900)' }}>4. Acceptable Use</h2>
            <p className="mb-4">You agree not to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Use the service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the service</li>
              <li>Copy, modify, or distribute our content without permission</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4" style={{ color: 'var(--color-gray-900)' }}>5. Data Accuracy</h2>
            <p className="mb-4">
              While we strive to provide accurate and up-to-date information, we make no warranties 
              about the completeness or accuracy of data displayed on the platform. Users should 
              verify critical information through official government sources.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4" style={{ color: 'var(--color-gray-900)' }}>6. Contact</h2>
            <p className="mb-4">
              For questions about these Terms, contact us at{' '}
              <a href="mailto:legal@tsap.ai" style={{ color: 'var(--color-primary)' }}>legal@tsap.ai</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
